import Component from '../Component';

class Header extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.setupEventListeners();
	}

	setupEventListeners() {
		this.refs['close'].addEventListener(
			'click', () => { 
				this.props.handleClose();
				this.dispatchCustomEvent('close-side-panel', this.refs['close']);
			}
		);
	}

	render() {
		return `
            <div class="sidepanel__header">
                <span ref="close" class="close" aria-label="Close">
                    <i class="fas fa-times"></i>
                </span>
            </div>`;
	}
}

export default Header;